import {
	default as EChartsReact,
	default as ReactECharts,
} from "echarts-for-react";
import React, { Component } from "react";
import { accuracySeries, ACTIVITY_ACCURACY } from "../../../api/types";

interface AppProp {
	onDownload: (urls: [string, string]) => void;
	data: accuracySeries[];
}

export class ActivityAccuracy extends Component<AppProp, {}> {
	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([ACTIVITY_ACCURACY, base64]);
		}
	}

	getMonth(): Array<string | undefined> {
		const d = new Date();
		const month_num = d.getMonth();
		const Month = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		const output = [];
		for (let now = month_num + 1; now <= 11; now++) {
			output.push(Month[now]);
		}
		for (let now = 0; now <= month_num; now++) {
			output.push(Month[now]);
		}

		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return output;
	}

	getOption(data: accuracySeries[]): Object {
		return {
			title: {
				text: "Activities Accuracy",
			},
			tooltip: {
				trigger: "axis",
			},
			grid: {
				left: "3%",
				right: "4%",
				bottom: "3%",
				containLabel: true,
				height: "60%",
				width: "80%",
			},
			xAxis: {
				type: "category",
				data: this.getMonth(),
			},
			yAxis: {
				type: "value",
			},
			legend: {},
			series: data,
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.data)}
				// style={{height: '250px', width: '500px'}}
			/>
		);
	}
}
